import { MESApiService } from "@dexteel/mesf-core";

export const getMoldSizes = async () => {
  const apiService = new MESApiService();
  return await apiService.callV2("[CAS].[GetMoldSizes]", []);
};
